import { Blueprint } from 'types';
import { PROJECT_TYPES } from 'utils/constants';

// Backend project type IDs (from backend enum)
// Only types available in UI are mapped
const PROJECT_TYPE_TO_ID: Record<string, number> = {
  [PROJECT_TYPES.event]: -1,
  [PROJECT_TYPES.gridDeferral]: -3,
  [PROJECT_TYPES.construction]: -4,
  [PROJECT_TYPES.electricVehicles]: -6,
  [PROJECT_TYPES.other]: -7,
  [PROJECT_TYPES.infrastructureSite]: -8,
};

const ID_TO_PROJECT_TYPE: Record<number, string> = {
  [-1]: PROJECT_TYPES.event,
  [-3]: PROJECT_TYPES.gridDeferral,
  [-4]: PROJECT_TYPES.construction,
  [-6]: PROJECT_TYPES.electricVehicles,
  [-7]: PROJECT_TYPES.other,
  [-8]: PROJECT_TYPES.infrastructureSite,
};

export const projectTypeStringToId = (projectType: string): number => {
  return PROJECT_TYPE_TO_ID[projectType] ?? -1;
};

export const projectTypeIdToString = (projectTypeId: number): string => {
  return ID_TO_PROJECT_TYPE[projectTypeId] ?? '';
};

export const getProjectTypeTranslationKey = (projectTypeId: number): string => {
  return `entities:projectType.values.${projectTypeId}`;
};

export const getSetupDetails = (blueprintDetails: Blueprint) => {
  return blueprintDetails.calculations.find((calc) => !calc.isBaseCalculation)?.setupDetails;
};
